import React from 'react'
import clsx from 'clsx'
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material'

import useStyles from '../AgentClientSearchToggle/styles'

const VerticalToggle = ({
  name,
  selected,
  onChange,
  options,
  style = {},
  className
}) => {
  const classes = useStyles()

  return (
    <FormControl className={clsx(classes.control, className)}>
      <RadioGroup
        name={name}
        value={selected}
        onChange={e => onChange(e.target.value)}
        style={style}
      >
        {options.map((val, i) => (
          <FormControlLabel
            key={i}
            value={val}
            label={val}
            control={
              <Radio color='primary' size='small' className={classes.radio} />
            }
            className={clsx(
              classes.controlLabel,
              val === selected && classes.controlLabelBold
            )}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default VerticalToggle
